import { gql } from '@urql/core';

export const ME_QUERY = gql`
  query Me {
    me {
      id
      name
      first_name
      last_name
      infix
      onfido_status
      onfido_checked
      onfido_hash
      terms_and_conditions_accepted
      roles {
        id
        type
        status
        role_data {
          ... on Advisor {
            type
            has_mandate
          }
          ... on InitialPerson {
            phones {
              phone
            }
          }
        }
      }
      documentContext {
        documentOwners {
          title
          items {
            name
          }
        }
      }
      documents {
        id
        records {
          id
          name
        }
      }
    }
  }
`;
